import Button from 'components/form/Button';

export function ViewOnDataMapButton({ path }: { path: string }) {
	return (
		<Button size="small" color="tertiary" href={path} data-test="data-map-link">
			View on data map
		</Button>
	);
}
